import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { htmlSafe, type SafeString } from '@ember/template';
import eq from 'ember-truth-helpers/helpers/eq';
import colorVar from 'volta/helpers/color-var';
import and from 'ember-truth-helpers/helpers/and';
import gt from 'ember-truth-helpers/helpers/gt';
import not from 'ember-truth-helpers/helpers/not';
import classNames from 'volta/helpers/class-names';
import cssVars from 'volta/modifiers/css-vars';
import or from 'ember-truth-helpers/helpers/or';
import orElse from 'volta/helpers/or-else';
import BvTooltip from 'volta/components/bv-tooltip';
import BvText from 'volta/components/bv-text';
import { concat } from '@ember/helper';
import isPresent from 'volta/helpers/is-present';
import type { THueVariationString } from 'volta/utils/style-utils';
import type { BvTooltipSignature } from './../bv-tooltip/index';
import type { TOC } from '@ember/component/template-only';
interface BvStatusSignature {
    Args: {
        abbreviated?: boolean;
        class?: string;
        color?: THueVariationString;
        isDone?: boolean;
        isError?: boolean;
        minimized?: boolean;
        progress?: number;
        status: string | SafeString;
        style?: string;
        temporary?: boolean;
        tooltip?: BvTooltipSignature['Args']['text'];
    };
    Blocks: {
        default: [];
    };
    Element: HTMLSpanElement;
}
const BvStatusComponent: TOC<BvStatusSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  {{#let
    (or (eq @progress 100) @isDone)
    (if @color (colorVar @color variant='4'))
    (if @color (colorVar @color variant='3'))
    as |isDone darkColor lightColor|
  }}
    {{#let (and (gt @progress 0) (not isDone)) as |hasProgress|}}
      <span
        class={{classNames
          'bv-status'
          (if @abbreviated 'bv-status--abbreviated')
          (if @minimized 'bv-status--minimized')
          (if isDone 'bv-status--is-done')
          (if @temporary 'bv-status--temporary')
          @class
        }}
        title={{@status}}
        style={{if @style (htmlSafe @style)}}
        ...attributes
        {{cssVars
          bv-status-bg-dark=darkColor
          bv-status-bg-light=lightColor
          bv-status-progress=(if hasProgress (concat '' @progress))
        }}
      >
        {{#unless @abbreviated}}
          <span class='bv-status__icon'>
            {{#if hasProgress}}
              <span class='bv-status__pie'></span>
            {{else if isDone}}
              <BvText @text='✓' />
            {{else if @isError}}
              <BvText @text='×' />
            {{else}}
              <span class='bv-status__dot'></span>
            {{/if}}
          </span>
        {{/unless}}
        {{#if @minimized}}
          <span class='u-visually-hidden'>
            {{@status}}
          </span>
        {{else if @abbreviated}}
          {{Abbreviate @status}}
        {{else if @status}}
          {{@status}}
        {{else}}
          {{yield}}
        {{/if}}
        {{#if (and (or @abbreviated @minimized) (isPresent (orElse @tooltip @status)))}}
          <BvTooltip @text={{orElse @tooltip @status}} />
        {{/if}}
      </span>
    {{/let}}
  {{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Abbreviate = (str: string | SafeString)=>str.toString()[0];
export default BvStatusComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvStatus: typeof BvStatusComponent;
        'bv-status': typeof BvStatusComponent;
    }
}
